import { Adjustment } from './adjustment';
import { Commission } from './commission';
import { Disposition } from './disposition';

export class Order {
  dispositionDTO?: Disposition;
  commissionDTOList?: Commission[];
  adjustmentDTOList?: Adjustment[];
}
